import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import rootReducer from '../reducers'
import configureStore from 'Shared/configureStore'
import AddTeamContainer from './AddTeamContainer'


const AddTeamRoot = ({
  fetchInitialDataURL,
}) => {
  const state = {
    misc: {
      fetchInitialDataURL,
    },
  }

  const store = configureStore(rootReducer, state)

  return <Provider store={ store }><AddTeamContainer></AddTeamContainer></Provider>
}

AddTeamRoot.propTypes = {
  fetchInitialDataURL: PropTypes.string.isRequired,
}

export default AddTeamRoot
